app.service("ColourService", ['$rootScope', 'AcquiredService',
    function ($rootScope, AcquiredService) {

        const siteHelper = $rootScope.site_helper;
        const modelConstructor = $rootScope.model_constructor;

        const ColourModel = modelConstructor.extend(AcquiredService.BasicAcquiredModel, {

            id: "colour",
            name: "Colour",

            site_range_id: null,

            valid_colour_ids: [],

            isValidAcquiredObject: isValidAcquiredObject,
            applyItemHandler: applyItemHandler
        });

        let cachedColours = {};

        function collectCachedColours() {

            cachedColours = {};

            const cacheLocalServerModel = $rootScope.model.cache_local_server;
            const siteRangeColours = cacheLocalServerModel.colour.site_range;
            if (!siteRangeColours) {
                return
            }
            for (let siteRangeID in siteRangeColours) {
                const colours = siteRangeColours[siteRangeID].choices;
                const cachedSiteRange = cacheLocalServerModel.site_range[siteRangeID];
                const requestRangeID = cachedSiteRange ? cachedSiteRange.request_range_id : null;
                if (!cachedColours[siteRangeID]) {
                    cachedColours[siteRangeID] = {};
                }
                for (let colourID in colours) {
                    let cachedColour = colours[colourID];
                    if (cachedColour.id) {
                        cachedColour = JSON.parse(JSON.stringify(cachedColour));
                        cachedColour.request_range_id = requestRangeID;
                        cachedColour.tags = cachedColour.tags ? cachedColour.tags : [];
                        if (!cachedColour.m2m) {
                            cachedColour.m2m = false;
                        }
                        if (!cachedColour.lead_time) {
                            cachedColour.lead_time = Number.MAX_SAFE_INTEGER;
                        }
                        cachedColours[siteRangeID][cachedColour.id] = cachedColour;
                    }
                }
            }
        }

        this.factory = new modelConstructor.ModelFactory({
            birth: function (values) {
                return new ColourModel(values);
            },

            validVariationPointers: function (variationIDs) {
                return ['browse_id', 'site_range_id', 'base_component_id', 'parent_category_group_id', 'parent_category_id', 'alpha_category_id', 'product_id', 'custom_id'];
            },

            applyModelVariation: applyModelVariation
        });

        function isValidAcquiredObject(acquiredObject) {

            const model = this.root;
            const objectID = acquiredObject.id;

            return model.valid_colour_ids.indexOf(objectID) !== -1;
        }


        function applyItemHandler(colour) {

            const model = this.root;
            const variationIDs = model.variation_ids;

            const siteRangeID = variationIDs.site_range_id;
            const customID = variationIDs.custom_id;

            const cachedColour = cachedColours[siteRangeID] ? cachedColours[siteRangeID][colour.id] : null;

            for (let key in cachedColour) {
                colour[key] = cachedColour[key];
            }
            colour.disabled = !!cachedColour.disabled;
            colour.disabled_temporarily = !!cachedColour.disabled_temporarily;

            if (colour.tags.indexOf("jaylbne") !== -1 && colour.tags.indexOf("jayline")) {
                colour.tags.push("jayline");
            }


            const limitedStock = !!colour.limited_stock || colour.tags.indexOf("limited_stock") !== -1;
            const promoteNew = !!colour.promote_new || colour.tags.indexOf("promote_new") !== -1;
            const comingSoon = !!colour.coming_soon || colour.tags.indexOf("coming_soon") !== -1;
            const backSoon = !!colour.back_soon || colour.tags.indexOf("back_soon") !== -1;

            colour.prominent_disabled = comingSoon || backSoon;

            let colourDetail = null;


            if (customID === "tallstor_drawer_box") {
                let name = colour.name;
                name = name.split("Matt ").join("");
                name = name.split("Dove ").join("");
                colour.name = name;
            }

            if (model.site_range_id === "valore") {
                if (colour.tags.indexOf("smooth") !== -1) {
                    colourDetail = "Smooth";
                }
            }
            colour.colour_detail = colourDetail;
            colour.colour_detailed_name = colour.name + (colour.colour_detail ? " (" + colour.colour_detail + ")" : "");

            let rootColourID = colour.id
            const rootColourPrefix = (siteRangeID ? siteRangeID : "") + "_";
            if (rootColourID.substring(0, rootColourPrefix.length) !== rootColourPrefix) {
                rootColourID = rootColourPrefix + rootColourID;
            }

            const baseColourIDs = {};
            const finishIDs = {};


            const cacheLocalServerModel = $rootScope.model.cache_local_server
            const baseColourChoices = cacheLocalServerModel.base_colour.choices;
            const finishChoices = cacheLocalServerModel.finish_option.choices;

            for (let i = 0; i < colour.tags.length; i++) {
                const tag = colour.tags[i];
                if (baseColourChoices[tag]) {
                    baseColourIDs[tag] = true;
                }
                if (finishChoices[tag]) {
                    finishIDs[tag] = true;
                }
            }

            colour.root_colour_id = rootColourID;
            colour.base_colour_ids = baseColourIDs;
            colour.finish_ids = finishIDs;
            colour.limited_stock = limitedStock;
            colour.promote_new = promoteNew;
            colour.coming_soon = comingSoon;
            colour.back_soon = backSoon;


            siteHelper.applyValues(colour, {
                collectImageParams: function () {
                    const params = this.super();
                    params.image_type_id = "colour";
                    params.site_range_id = model.site_range_id;
                    params.colour_id = colour.id;
                    return params;
                },
            });
        }

        function applyModelVariation(model) {

            this.super(model);
            //console.log("new Colour model!!!!!")
            //console.log(model.model_variation_id)

            let colourID;

            const variationIDs = model.variation_ids;

            const browseID = variationIDs.browse_id;
            const siteRangeID = variationIDs.site_range_id;
            const customID = variationIDs.custom_id;

            const baseComponentID = variationIDs.base_component_id;
            const parentCategoryGroupID = variationIDs.parent_category_group_id;
            const parentCategoryID = variationIDs.parent_category_id;
            const alphaCategoryID = variationIDs.alpha_category_id;
            const productID = variationIDs.product_id;

            const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID);

            siteHelper.applyValues(model, {
                request_endpoint: '/request/api.php/ranges/' + requestRangeID + '/colours',
                request_range_id: requestRangeID,
                site_range_id: siteRangeID
            });

            const simulateAcquiredObjects = {};

            let colourExpected = true;
            if (browseID === "component") {
                const componentObject = $rootScope.service.cache_local_server.getAnySiteRangeComponentObject(variationIDs.base_component_id, variationIDs.parent_category_group_id, variationIDs.parent_category_id, variationIDs.alpha_category_id);
                if (componentObject && !componentObject.requires_colour) {
                    colourExpected = false
                }
            }

            let validColourIDs = null;
            if (customID === "tallstor_cabinet") {
                if (siteRangeID === "valore") {
                    validColourIDs = ["white", "light_grey", "anthracite", "urban_oak", "dust_grey"];
                } else {
                    validColourIDs = [];
                }
            } else if (customID === "tallstor_drawer_box") {
                if (siteRangeID === "valore") {
                    validColourIDs = ["light_grey", "anthracite"];
                } else if (siteRangeID === "bella") {
                    validColourIDs = ["matt_dove_grey", "matt_graphite"];
                } else if (siteRangeID === "zurfiz") {
                    validColourIDs = ["supermatt_light_grey", "supermatt_graphite"];
                } else {
                    validColourIDs = [];
                }
            }

            function validateCachedColour(cachedColour) {
                return cachedColour && !cachedColour.disabled && !(cachedColour.disabled_temporarily && customID)
            }


            let siteRangeCachedColours = cachedColours[siteRangeID];
            siteRangeCachedColours = siteRangeCachedColours ? siteRangeCachedColours : {};
            if (validColourIDs) {
                for (let i = 0; i < validColourIDs.length; i++) {
                    if (!validateCachedColour(siteRangeCachedColours[validColourIDs[i]])) {
                        validColourIDs.splice(i, 1);
                        i--;
                    }
                }
            } else {
                validColourIDs = [];
                for (colourID in siteRangeCachedColours) {
                    if (validateCachedColour(siteRangeCachedColours[colourID])) {
                        validColourIDs.push(colourID);
                    }
                }
            }

            const colourExceptions = $rootScope.service.cache_local_server.getColourExceptions(
                siteRangeID,
                baseComponentID,
                parentCategoryGroupID,
                parentCategoryID,
                alphaCategoryID,
                productID
            );
            for (let i = 0; i < validColourIDs.length; i++) {
                if (colourExceptions.includes(validColourIDs[i])) {
                    validColourIDs.splice(i, 1);
                    i--;
                }
            }
            if (!colourExpected && validColourIDs.length) {
                if (validColourIDs.length) {
                    validColourIDs.length = 1;
                }
            }

            model.colour_expected = colourExpected;
            model.valid_colour_ids = validColourIDs;


            if (siteRangeCachedColours) {
                for (colourID in siteRangeCachedColours) {
                    if (validColourIDs.indexOf(colourID) !== -1) {
                        const cachedColour = siteRangeCachedColours[colourID];
                        simulateAcquiredObjects[cachedColour.id] = JSON.parse(JSON.stringify(cachedColour))
                    }

                }
            }


            model.buildAcquiredChoices(simulateAcquiredObjects);

            for (colourID in model.choices) {
                const colour = model.choices[colourID];
                colour.disabled = true;
            }

        }


        this.indexInit = function () {

            $rootScope.service.cache_local_server.requireInitialized(function () {
                collectCachedColours();
            });
        }
    }])